import type { ReactNode } from 'react';
import { css } from 'styled-system/css';

export function HeadCell({
  children,
  align,
}: {
  children: ReactNode;
  align?: 'right';
}) {
  return (
    <span
      className={css({
        paddingInline: '3',
        paddingBlock: '2',
        borderLeft: '1px solid token(colors.border.hairline)',
        textAlign: align,
        '&:last-child': {
          borderRight: '1px solid token(colors.border.hairline)',
        },
      })}
    >
      {children}
    </span>
  );
}
